// src/components/ExamTimer.tsx
import Field from '../shared/field';
import { useTimerWorker } from '../../hooks/index/use-timer-worker';

export type ExamTimerPropsType = {
  /** Initial countdown time in seconds */
  remainSeconds: number;
  /** Callback when timer reaches zero */
  onFinish: () => void;
};

/**
 * Exam timer component using Web Worker for precise timing
 * Supports multiple concurrent timers with independent states
 */
function ExamTimer({ remainSeconds, onFinish }: ExamTimerPropsType) {
  // Use worker timer hook for accurate countdown
  const seconds = useTimerWorker(remainSeconds, onFinish);

  /**
   * Format seconds into HH:MM:SS or MM:SS display
   * @returns Formatted time string
   */
  const formatTime = () => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    // Show hours only if needed
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds
        .toString()
        .padStart(2, '0')}`;
    }

    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return <Field title='زمان باقی مانده' content={formatTime()} />;
}

export default ExamTimer;
